<template>
  <div>
    <div v-if="orderNotAvailable">
      <block-order :styles="styles"></block-order>
    </div>
    <div v-else>
      <progress-steps
        v-if="
          (currentOs && currentStep !== 4) || (!currentOs && currentOs !== 6)
        "
        order="licence"
        :isAccountant="isAccountant"
        :skpCompanyAdd="skpCompanyAdd"
        :skpAccountantAdd="skpAccountantAdd"
      ></progress-steps>
      <div v-if="currentStep === 1">
        <order-change-licence-form :styles="styles"></order-change-licence-form>
      </div>
      <div v-if="currentStep === 2 && !currentOs">
        <order-products
          :isAccountant="isAccountant"
          :accountantAdd="accountantAdd"
          :skpAdd="skpAdd"
          :skpCompanyAdd="skpCompanyAdd"
          :skpAccountantAdd="skpAccountantAdd"
          :styles="styles"
          v-on:addedproduct="filterCloudOptions"
          v-on:clouddatabyclient="updateCloudDataByClient"
          changeLicence="true"
        ></order-products>
      </div>
      <div v-if="currentStep === 3 && !currentOs">
        <order-cloud
          :cloudOptions="filteredCloudOptions"
          :isAccountant="isAccountant"
          :skpAdd="skpAdd"
          :skpCompanyAdd="skpCompanyAdd"
          :skpAccountantAdd="skpAccountantAdd"
          :program="program"
          :styles="styles"
        ></order-cloud>
      </div>
      <div
        v-if="
          (currentStep === 2 && currentOs) || (currentStep === 4 && !currentOs)
        "
      >
        <order-delivery
          :isAccountant="isAccountant"
          :skpAdd="skpAdd"
          :skpAccountantAdd="skpAccountantAdd"
          :styles="styles"
        ></order-delivery>
      </div>
      <div
        v-if="
          (currentStep === 3 && currentOs) || (currentStep === 5 && !currentOs)
        "
      >
        <order-summary
          :cloudOptions="filteredCloudOptions"
          :isAccountant="isAccountant"
          :skpCompanyAdd="skpCompanyAdd"
          :skpAccountantAdd="skpAccountantAdd"
          :program="program"
          :styles="styles"
        ></order-summary>
      </div>
      <div
        v-if="
          (currentStep === 4 && currentOs) || (currentStep === 6 && !currentOs)
        "
      >
        <order-submitted></order-submitted>
      </div>
    </div>
  </div>
</template>

<script>
import OrderChangeLicenceForm from './partials/order/OrderChangeLicenceForm';
import ProgressSteps from './partials/order/ProgressSteps';
import OrderProducts from './partials/order/OrderProducts';
import OrderCloud from './partials/order/OrderCloud';
import OrderDelivery from './partials/order/OrderDelivery';
import OrderSummary from './partials/order/OrderSummary';
import OrderSubmitted from './partials/order/OrderSubmitted';
import BlockOrder from './partials/order/BlockOrder';
import { mapGetters } from 'vuex';
import {
  sam_plans,
  skp_plans,
  skp_plans_B,
  skp_plans_F,
} from './config/cloudPlans';
import moment from 'moment';

export default {
  name: 'OrderChangeLicence',
  components: {
    OrderChangeLicenceForm,
    ProgressSteps,
    OrderProducts,
    OrderCloud,
    OrderSummary,
    OrderDelivery,
    OrderSubmitted,
    BlockOrder,
  },
  props: {
    styles: {},
  },
  data() {
    return {
      allCloudOptions: {},
      filteredCloudOptions: {},
      cloudData: {},
      year: process.env.MIX_AKTU_YEAR,
      cloudDiscount: null,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
      currentStep: 'order/currentStep',
      cartProducts: 'order/getCartProducts',
      client: 'auth/client',
      currentOs: 'auth/currentOs',
      currentCloud: 'order/currentCloud',
    }),
    isAccountant() {
      return (
        (this.client.MDS !== null &&
          this.client.MDS !== '' &&
          this.client.MDS.split('').includes('B')) ||
        this.accountantAdd
      );
    },
    accountantAdd() {
      return (
        this.cartProducts.filter(
          (row) => row.key === 'B1' || row.key === 'B2' || row.key === 'B3'
        ).length > 0
      );
    },
    skpAdd() {
      let product = this.cartProducts.filter(
        (row) =>
          (row.UWAGI === 'N_SKP' && row.key !== 'O') ||
          ((row.key === 'B1' || row.key === 'B2' || row.key === 'B3') &&
            this.program === 'sam')
      );

      return product.length > 0 ? product[0] : null;
    },
    skpCompanyAdd() {
      return this.skpAdd && this.skpAdd.key === 'PODST';
    },
    skpAccountantAdd() {
      return (
        this.skpAdd &&
        (this.skpAdd.key === 'B1' ||
          this.skpAdd.key === 'B2' ||
          this.skpAdd.key === 'B3')
      );
    },
    orderNotAvailable() {
      return (
        !(
          this.year + '-01-01' <= moment().format('YYYY-MM-DD') &&
          this.year + '-12-01' > moment().format('YYYY-MM-DD')
        ) && this.licence != 1
      );
    },
  },
  created() {
    this.$store.dispatch('auth/me');
    this.getCloudDiscount();
    this.getCloudOptions();
  },
  methods: {
    getCloudDiscount() {
      axios
        .get('/api/getCloudDiscount/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          if (data) {
            this.cloudDiscount = data;
            this.$store.commit('order/addDiscount', this.cloudDiscount);
          }
        });
    },
    getCloudOptions() {
      if (!this.currentOs) {
        axios
          .get('/api/getCloudOptions/' + this.program + '/' + this.licence)
          .then(({ data }) => {
            this.allCloudOptions = data;
            this.filterCloudOptions();
          });
      }
    },
    filterCloudOptions() {
      let options = [];
      if (
        this.accountantAdd ||
        (this.program === 'skp' && this.isAccountant) ||
        this.skpAccountantAdd
      ) {
        options = this.filterAccountantCloudOptions();
      } else if (
        this.skpCompanyAdd ||
        (this.program === 'skp' && !this.isAccountant)
      ) {
        options = this.filterCompanyCloudOptions();
      } else if (this.program === 'sam') {
        options = this.filterSamCloudOptions();
      }

      this.filteredCloudOptions = options.reduce(
        (i, item) => ({ ...i, [item.value]: item }),
        {}
      );
    },
    filterCompanyCloudOptions() {
      let options = [];

      Object.values(this.allCloudOptions).forEach(function (option) {
        Object.values(skp_plans_F).forEach(function (planId) {
          if (option.value === planId) {
            options.push(option);
          }
        });
      });

      return options;
    },
    filterAccountantCloudOptions() {
      let options = [];

      Object.values(this.allCloudOptions).forEach(function (option) {
        Object.values(skp_plans_B).forEach(function (planId) {
          if (option.value === planId) {
            options.push(option);
          }
        });
      });

      return options;
    },
    filterSamCloudOptions() {
      let options = [];

      Object.values(this.allCloudOptions).forEach(function (option) {
        Object.values(sam_plans).forEach(function (planId) {
          if (option.value === planId) {
            options.push(option);
          }
        });
      });

      return options;
    },
    updateCloudDataByClient() {
      let that = this;
      let plan = this.currentCloud.plan;
      Object.values(this.allCloudOptions).forEach(function (option) {
        if (option.value === plan) {
          that.$store.commit('order/setCurrentCloudPrice', option.net);
        }
      });
      if (!this.currentCloud.plan) {
        this.applyDiscount();
      }
    },
    applyDiscount() {
      if (this.cloudDiscount) {
        let that = this;
        Object.values(this.allCloudOptions).forEach(function (option) {
          option.net =
            option.net - option.net * (that.cloudDiscount['percent'] / 100);
          option.gross =
            option.gross - option.gross * (that.cloudDiscount['percent'] / 100);
        });
      }
    },
  },
};
</script>

<style scoped></style>
